import { render, staticRenderFns } from "./DropdownFinishes.vue?vue&type=template&id=70042a04&scoped=true"
import script from "./DropdownFinishes.vue?vue&type=script&lang=ts"
export * from "./DropdownFinishes.vue?vue&type=script&lang=ts"
import style0 from "./DropdownFinishes.vue?vue&type=style&index=0&id=70042a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70042a04",
  null
  
)

export default component.exports